module.exports = __webpack_public_path__ + "img/logo.be06f74a.svg";